var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "MainLayout",
    { attrs: { "page-name": "user-master" } },
    [
      _c(
        "PageHeader",
        { attrs: { title: _vm.title } },
        [
          _c(
            "el-row",
            { staticClass: "header-button" },
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "register",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickRegister }
                    },
                    [_vm._v("新規追加")]
                  )
                ],
                1
              ),
              _c(
                "el-col",
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "detail-search",
                      attrs: { type: "primary" },
                      on: { click: _vm.clickDetailSearch }
                    },
                    [_vm._v("詳細検索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "SimpleSearch",
            {
              attrs: { model: _vm.simpleSearchFormModel },
              on: { search: _vm.clickSearch }
            },
            [
              _c("UserId", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.userIdSet,
                  prop: "user_id"
                },
                model: {
                  value: _vm.simpleSearchFormModel.user_id,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "user_id", $$v)
                  },
                  expression: "simpleSearchFormModel.user_id"
                }
              }),
              _c("UserName", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.userNameSet
                },
                model: {
                  value: _vm.simpleSearchFormModel.user_name,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "user_name", $$v)
                  },
                  expression: "simpleSearchFormModel.user_name"
                }
              }),
              _c("CustomerCode", {
                attrs: {
                  searchCond: true,
                  "autocomplete-list": _vm.customerCodeSet,
                  initialize: true,
                  label: "請求先"
                },
                model: {
                  value: _vm.simpleSearchFormModel.customer_code,
                  callback: function($$v) {
                    _vm.$set(_vm.simpleSearchFormModel, "customer_code", $$v)
                  },
                  expression: "simpleSearchFormModel.customer_code"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("Table", {
        attrs: {
          "table-data": _vm.tableData,
          "default-sort": { prop: "user_id", order: "ascending" }
        },
        on: { "row-click": _vm.clickRow, "multiple-delete": _vm.deleteRows },
        scopedSlots: _vm._u([
          {
            key: "columns",
            fn: function() {
              return [
                _c("UserIdColumn"),
                _c("UserNameColumn"),
                _c("CustomerCodeColumn"),
                _c("PhoneNumberColumn"),
                _c("EmailColumn"),
                _c("RoleIdColumn"),
                _c("MenuColumn", {
                  attrs: { cbdelete: _vm.deleteRow },
                  on: { copy: _vm.copyRow }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _c("UserMasterRegisterDialog", {
        attrs: {
          visible: _vm.registerDialogVisible,
          "autocomplete-user-id-set": _vm.userIdSet,
          "autocomplete-user-name-set": _vm.userNameSet,
          "autocomplete-customer-code-set": _vm.customerCodeSet,
          "current-row": _vm.currentRow
        },
        on: {
          "update:visible": function($event) {
            _vm.registerDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      }),
      _c("UserMasterDetailSearchDialog", {
        attrs: {
          visible: _vm.detailDalogVisible,
          "autocomplete-user-id-set": _vm.userIdSet,
          "autocomplete-user-name-set": _vm.userNameSet,
          "autocomplete-customer-code-set": _vm.customerCodeSet
        },
        on: {
          "update:visible": function($event) {
            _vm.detailDalogVisible = $event
          },
          search: _vm.detailSearch
        }
      }),
      _c("UserMasterEditDialog", {
        attrs: {
          visible: _vm.editDialogVisible,
          "autocomplete-user-id-set": _vm.userIdSet,
          "autocomplete-user-name-set": _vm.userNameSet,
          "autocomplete-customer-code-set": _vm.customerCodeSet,
          "current-row": _vm.currentRow,
          programName: "UserMasterPage"
        },
        on: {
          "update:visible": function($event) {
            _vm.editDialogVisible = $event
          },
          refresh: _vm.refreshSearch
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }